import { Box } from '@mui/material';
import CustomDialog from 'components/custom-dialog/custom-dialog.component';
import Spinner from 'components/spinner/spinner.component';
import AccountInboxMessage from 'pages/account-inbox/account-inbox-message/account-inbox-message.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectIsLoading } from 'redux/user/user.selectors';

const MessagesDialog = ({
  open,
  checkoutPromoCode,
  setOpen,
  messages,
  testId,
  preview,
}) => {
  const { t } = useTranslation();
  const isLoading = useSelector(selectIsLoading);
  return (
    <CustomDialog
      open={open}
      title={
        checkoutPromoCode
          ? t('messagesDialog.checkoutPromoCode.title')
          : t('messagesDialog.title')
      }
      testId={testId}
      close={() => setOpen(false)}
    >
      {isLoading && <Spinner />}
      {messages.length &&
        messages.map(message => (
          <Box pb={2}>
            <AccountInboxMessage
              message={message}
              handleClose={() => setOpen(false)}
              checkoutPromoCode={checkoutPromoCode}
              key={
                message.distributedMessageId
                  ? message.distributedMessageId
                  : message.distributedOfferId
              }
              preview={preview}
            />
          </Box>
        ))}
    </CustomDialog>
  );
};

export default MessagesDialog;
